module.exports = __webpack_public_path__ + "img/wind-single.401b19c.svg";